<template>
 <div class="imballi-card" v-if="isLoaded">
   <div class="row">
     <div class="col-md-4">
       <p>{{ info.descrizione }}</p>
     </div>
     <div class="col-md-4">
       <b-field label="Colli">
         <b-numberinput size="is-small" type="is-dark" controls-position="compact" disabled v-model="imballi.numImballi"></b-numberinput>
       </b-field>
     </div>
     <div class="col-md-4"></div>
   </div>
 </div>
</template>

<script>
export default {
  name: "imballi-card",
  props: ['imballi', 'chiave'],
  data() {
    return {
      info: null,
      isLoaded: false,
    }
  },
  mounted() {
    this.getImballiInfo()
  },
  methods: {
    getImballiInfo: function () {
      axios({
        method: 'get',
        url: window.location.origin + '/b2b/imballiInfo',
        params: {
          codImballo: this.imballi.codImballo
        }
      })
      .then(res =>{
        //console.log('imballiInfo', res.data)
        this.info = res.data[0]
        this.isLoaded = true
        this.$emit('loaded', this.chiave)
      })

    }
  },
}
</script>

<style lang="scss" scoped>
.imballi-card {
  display: none;
  width: 100%;
  background-color: #f5f5f5;
  margin: 2px 0;
}

</style>